import React from 'react';
import Form from '../molecules/Form';
import TabNavigation from '../molecules/TabNavigation';
import Heading from '../molecules/Heading';
import '../../styles/Styles.css'

const TabbedLayout = React.forwardRef(({ activeTab, setActiveTab, domain, setDomain, error, setError, setSettings, onclick, setButtonEnabled }, ref) => {

    //const buttonStatus = setButtonEnabled;
    //console.log("Button status in parent", buttonStatus);

    return(
        <div className='tablayout-container'>
        <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} />
        {activeTab === 'Screen1' && (
            <>
                <Heading />
                <Form domain={domain} setDomain={setDomain} error={error} setError={setError} setSettings={setSettings} onclick={onclick} setButtonEnabled={setButtonEnabled} ref={ref} />
            </>
        )}
        {/*{activeTab === 'Screen2' && (
            <div><p>Content for Screen 2</p></div>
        )}*/}
    </div>
    );
});
export default TabbedLayout;